export default "__VITE_ASSET__DTw4q2No__"